export default class extends Controller {
  static targets = ["infoContainer"];

  connect() {
    App.Helpers.listenToCustomEvent(document, "control:expand", this.expandDetails.bind(this));
    App.Helpers.listenToCustomEvent(document, "control:collapse", this.closeDetails.bind(this));
  }

  expandDetails(event) {
    const { containerID } = event.detail;
    if (containerID == this.containerID) {
      this.showInfo = true;
    }
  }

  closeDetails(event) {
    const { containerID } = event.detail;
    if (containerID == this.containerID) {
      this.showInfo = false;
    }
  }

  //
  // GETTERS AND SETTERS
  //

  get showInfo() {
    return this.infoContainerTarget.classList.contains("showing");
  }

  set showInfo(val) {
    this.infoContainerTarget.classList[val ? "add" : "remove"]("showing");
    setTimeout(this.toggleOffClickEventListener, 20);
  }

  get containerID() {
    return this.data.get("record-id");
  }
};



// WEBPACK FOOTER //
// ./app/components/data_displays/assets/javascript/data-displays-expandable-metadata-info-controller.js